import { create } from 'zustand';

import { localStorageUtil } from '../../utils/local-storage.util';

const scenarioCapTableGeneratedLocalStorage = localStorageUtil<boolean>(
  'scenarioCapTableGenerated',
);

type ScenarioCapTableGeneratedState = {
  delete: () => void;
  get: () => boolean;
  key: string;
  set: (value: boolean) => void;
  value: boolean;
};

export const scenarioCapTableGeneratedStore = create<ScenarioCapTableGeneratedState>()(
  (set, get) => ({
    key: 'scenarioCapTableGenerated',
    value: scenarioCapTableGeneratedLocalStorage.get() ?? false,
    delete: () => {
      scenarioCapTableGeneratedLocalStorage.delete();
      set({ value: false });
    },
    get: () => get().value,
    set: (newValue) => {
      scenarioCapTableGeneratedLocalStorage.set(newValue);
      set({ value: newValue });
    },
  }),
);
